import { createFileRoute } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { ProfileAccountView } from '@/views/profile/profile-account-view.tsx';

export const Route = createFileRoute('/_learner/profile/account')({
  component: ProfileAccountPage,
});

function ProfileAccountPage() {
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return <ProfileAccountView user={user} />;
}
